import IBroker from './IBroker';
import INote from './INote';

export function transformBrokerAdd(broker: IBroker): any {
    return {
        aclNumber: broker.aclNumber,
        aggregatorUuid: broker.aggregatorUuid,
        bdmUuid: broker.bdmUuid,
        companyName: broker.companyName,
        email: broker.email,
        firstName: broker.firstName,
        hasBeenBankrupted: broker.hasBeenBankrupted,
        hasBeenConvicted: broker.hasBeenConvicted,
        hasIndemnityInsurance: broker.hasIndemnityInsurance,
        insuranceExpiryDate: broker.insuranceExpiryDate,
        lastName: broker.lastName,
        linkedInUrl: broker.linkedInUrl,
        membershipExpiryDate: broker.membershipExpiryDate,
        phone: broker.phone,
        photoIdExpiryDate: broker.photoIdExpiryDate,
        postalAddress: broker.postalAddress,
        postcode: broker.postcode,
        state: broker.state,
        suburb: broker.suburb,
        type: broker.type,
    };
}

export function transformBrokerUpdate(broker: IBroker): any {
    return {
        aclNumber: broker.aclNumber,
        aggregatorUuid: broker.aggregatorUuid,
        bdmUuid: broker.bdmUuid,
        companyName: broker.companyName,
        firstName: broker.firstName,
        hasBeenBankrupted: broker.hasBeenBankrupted,
        hasBeenConvicted: broker.hasBeenConvicted,
        hasIndemnityInsurance: broker.hasIndemnityInsurance,
        insuranceExpiryDate: broker.insuranceExpiryDate,
        lastName: broker.lastName,
        linkedInUrl: broker.linkedInUrl,
        membershipExpiryDate: broker.membershipExpiryDate,
        phone: broker.phone,
        photoIdExpiryDate: broker.photoIdExpiryDate,
        postalAddress: broker.postalAddress,
        postcode: broker.postcode,
        state: broker.state,
        suburb: broker.suburb,
        type: broker.type,
    };
}

export function transformBrokerNote(note: INote): any {
    return {
        note: note.note,
    };
}
